export const extractPlaybackAndToken = url => {
	try {
		const parsedUrl = new URL(url);
		const pathnameParts = parsedUrl.pathname.split('/');
		const fileName = pathnameParts[pathnameParts.length - 1];
		const playbackId = fileName.replace('.m3u8', '');

		const token = parsedUrl.searchParams.get('token');

		return { playbackId, token };
	} catch (err) {
		console.error('Invalid URL:', err);
		return { playbackId: null, token: null };
	}
};
